import { PropsWithChildren } from 'react';

import {
  DropdownMenuItemRouter,
  PageHeaderDropdownMenuItem,
} from './PageHeaderDropdownMenu';

type Props = {
  to: string;
  isStaff: boolean;
  qaId?: string;
  onClick: () => void;
};

export function PageHeaderDropdownConditionalMenuItem({
  to,
  isStaff,
  children,
  qaId,
  onClick,
}: PropsWithChildren<Props>) {
  if (isStaff) {
    return (
      <PageHeaderDropdownMenuItem href={to} onClick={onClick} data-qa-id={qaId}>
        {children}
      </PageHeaderDropdownMenuItem>
    );
  }

  return (
    <DropdownMenuItemRouter onClick={onClick} to={to} data-qa-id={qaId}>
      {children}
    </DropdownMenuItemRouter>
  );
}
